import Vue from 'vue'
import Vuex from 'vuex'
import authen from './core/authen'
import main from './core/main'
import sso from './core/sso'
import auth from './core/auth'
import member from './member'
import newmember from './newmember'
import team from './team'
import newteam from './newteam'
import question from './question'
import reward from './reward'
import dashboard from './dashboard'
import people from './people'
import teams from './teams'
import spotlight from './spotlight'
import settings from './settings'
import billing from './billing'
import managers from './managers'
import custom from './custom'
import report from './report'
import reportPreview from './report-preview'
import membermanager from './membermanager'
import outbox from './outbox'
import powerups from './powerups'
import happilyvillage from './happily-village'
import happilyvillageUniversity from './happily-village-university'
import happilyvillageTownhall from './happily-village-townhall'
import happilyvillageRunningtrack from './happily-village-runningtrack'
import insightsManagers from './insights-managers'
import insightsCohorts from './insights-cohorts'
import integrations from './integrations'
import sparks from './sparks'
import nudges from './nudges'
import activity from './activity'
import happilyvillageBattleStadium from './happily-village-battle-stadium'
import monthlyInsignhts from './monthly-insignhts'
import monthlyEngaged from './monthly-engaged'
import monthlyStrength from './monthly-strength'
import awards from './awards'
import membersCohort from './members-cohort'
import register from './register'
import relationships from './relationships'
import skillOverview from './skill-overview'
import powerSkill from './power-skill'
import leaderboards from './leaderboards'
import performance from './performance'
import demomode from './demomode'
import navCommands from './nav-commands'
import learningJourneys from './learning-journeys'
import focus from './focus'
import goals from './goals'
import accountSwitcher from './core/account-switcher'
import quarterlyReport from './quarterly-report'
import slack from './slack'
import talentMatrix from './talent-matrix'
Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
      authen,
      sso,
      auth,
      member,
      newmember,
      team,
      newteam,
      question,
      reward,
      dashboard,
      people,
      teams,
      spotlight,
      settings,
      billing,
      managers,
      custom,
      report,
      reportPreview,
      membermanager,
      outbox,
      powerups,
      happilyvillage,
      happilyvillageTownhall,
      happilyvillageRunningtrack,
      happilyvillageUniversity,
      insightsManagers,
      insightsCohorts,
      integrations,
      sparks,
      nudges,
      activity,
      happilyvillageBattleStadium,
      monthlyInsignhts,
      monthlyEngaged,
      monthlyStrength,
      awards,
      membersCohort,
      register,
      main,
      relationships,
      skillOverview,
      powerSkill,
      leaderboards,
      performance,
      demomode,
      navCommands,
      learningJourneys,
      focus,
      goals,
      accountSwitcher,
      quarterlyReport,
      slack,
      talentMatrix
  }
})

